<template>
  <div>
    <div v-if="data && data.type === 'error'" class="error-msg-1">
      <v-icon>mdi-alert-circle</v-icon>{{ data.message }}
    </div>
    <div v-else-if="data && data.type === 'success'" class="error-msg-1">
      <v-icon>mdi-checkbox-marked-circle</v-icon>{{ data.message }}
    </div>
    <div v-else class="error-msg-1">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: "inputError",
  props: ["data"],
  data() {
    return {};
  },
};
</script>
